import { useCallback } from "react"

import { useGetVariant } from "./useGetVariant"

type UseGetIsFeatureEnabledOptions = {
  defaultValue?: string
  enabledValue?: string
}

export const useGetIsFeatureEnabled = (
  name: string,
  { defaultValue = "off", enabledValue = "on" }: UseGetIsFeatureEnabledOptions = {},
): (() => boolean) => {
  const getVariant = useGetVariant(name, defaultValue)

  return useCallback(() => getVariant().value === enabledValue, [enabledValue, getVariant])
}
